const _i18n_error = {
  required_code : {
    EN: `Code required`,
    KO: `Code required`,
    JP: `コードが必要です`
  },
}

const i18n_toastr = { _i18n_error }

export default i18n_toastr